import { FlexColumn } from "../../../../../../Common/__styles__/Layout";
import { Body } from "../../../../../../Common/Typography";
import { SelectionCard } from "../../../../../../Inputs/SelectionCard";
import { useBuilderWatch } from "../../form/form";
import { useAddModule } from "../../modules/add";
import { MODULES } from "../../modules/list";

export function ModulesList() {
  const addModule = useAddModule();

  const selectedModules = useBuilderWatch("modules");
  const addableModules = MODULES.filter(
    ({ type }) => !selectedModules.includes(type),
  );

  if (!addableModules.length) {
    return null;
  }

  return (
    <FlexColumn gap="s">
      <Body size="default" type="emphasis">
        Modules
      </Body>
      <SelectionCard.Group
        direction="vertical"
        spacing="compact"
        handleSelection={addModule}
      >
        {addableModules.map(module => {
          const { label } = module;
          return (
            <SelectionCard.Item
              key={label}
              value={module}
              aria-label={`Add ${label} Module`}
              borderStyle="ghost"
              size="compact"
            >
              <SelectionCard.CommonContent title={label} iconName="component" />
            </SelectionCard.Item>
          );
        })}
      </SelectionCard.Group>
    </FlexColumn>
  );
}
